/**
 * @generated SignedSource<<174c607815875ccea4f5a967fdb2cf28>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PageKind = "LANDING" | "FORM" | "CONFIRM" | "THANKS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ABTestForm_site$data = {
  readonly funnels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly confirmPage: {
          readonly id: string;
          readonly name: string;
          readonly kind: PageKind;
          readonly url: string;
          readonly sortNumber: number;
        } | null;
        readonly landingPage: {
          readonly id: string;
          readonly name: string;
          readonly kind: PageKind;
          readonly url: string;
          readonly sortNumber: number;
        } | null;
        readonly formPage: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
          readonly kind: PageKind;
          readonly url: string;
          readonly sortNumber: number;
        }> | null;
        readonly thanksPage: {
          readonly id: string;
          readonly name: string;
          readonly kind: PageKind;
          readonly url: string;
          readonly sortNumber: number;
        } | null;
      } | null;
    } | null> | null;
  };
  readonly owner: {
    readonly schedules: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly startTime: string | null;
          readonly endTime: string | null;
        } | null;
      } | null> | null;
    };
  };
  readonly " $fragmentType": "ABTestForm_site";
};
export type ABTestForm_site = ABTestForm_site$data;
export type ABTestForm_site$key = {
  readonly " $data"?: ABTestForm_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"ABTestForm_site">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "kind",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sortNumber",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ABTestForm_site",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FunnelConnection",
      "kind": "LinkedField",
      "name": "funnels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FunnelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Funnel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Page",
                  "kind": "LinkedField",
                  "name": "confirmPage",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Page",
                  "kind": "LinkedField",
                  "name": "landingPage",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Page",
                  "kind": "LinkedField",
                  "name": "formPage",
                  "plural": true,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Page",
                  "kind": "LinkedField",
                  "name": "thanksPage",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": {
                "direction": "ASC",
                "field": "START_TIME"
              }
            }
          ],
          "concreteType": "ScheduleConnection",
          "kind": "LinkedField",
          "name": "schedules",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ScheduleEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Schedule",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startTime",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endTime",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "schedules(orderBy:{\"direction\":\"ASC\",\"field\":\"START_TIME\"})"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};
})();

(node as any).hash = "7c8600f9f23bb8842d18f5e0cc3f5cd1";

export default node;
